var checkCurrentLocation, cllCookie, detectCurrentLocation, error, errorCallback, success, successCallback,
  slice = [].slice;

cllCookie = require('./m_location_helper').cllCookie;

successCallback = void 0;

errorCallback = void 0;


/*
 * HTML5 Geolocation API success callback
 *
 * @callback success
 * @param   {Object}   position        - Position information returned by Geolocation API
 * @returns {function} successCallBack - Callback to proceed in the search form submit
 */

success = function(position) {
  var lat, lng, ref;
  ref = position != null ? position.coords : void 0, lat = ref.latitude, lng = ref.longitude;
  Groupon.Utils.trackEvent('client-geolocate-successful', {
    lat: lat,
    lng: lng
  });
  setInterval(checkCurrentLocation, 1000 * 60 * 5);
  cllCookie.set(position);
  return typeof successCallback === "function" ? successCallback({
    lat: lat,
    lng: lng,
    current: true
  }) : void 0;
};


/*
 * HTML5 Geolocation API error callback
 *
 * @callback error
 * @param   {Object}   err           - Error object returned by Geolocation API
 * @returns {Function} errorCallback - Callback to exit search form submit
 */

error = function(err) {
  Groupon.Utils.trackEvent('client-geolocate-failed', err);
  cllCookie.remove(err);
  return typeof errorCallback === "function" ? errorCallback(err) : void 0;
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Object}   [positionOptions] - Configuration  of Geolocation API (Optional)
 * @param {Function} [successCB]       - Callback for successful geolocation (Optional)
 * @param {Function} [errorCB]         - Callback for failed geolocation (Optional)
 */

checkCurrentLocation = function(positionOptions, successCB, errorCB) {
  if (positionOptions == null) {
    positionOptions = {};
  }
  if (successCB == null) {
    successCB = cllCookie.set;
  }
  if (errorCB == null) {
    errorCB = cllCookie.remove;
  }
  if (positionOptions.maximumAge || positionOptions.timeout) {
    navigator.geolocation.getCurrentPosition(successCB, errorCB, positionOptions);
  } else {
    navigator.geolocation.getCurrentPosition(successCB, errorCB);
  }
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Function[]} arg                   - Splat of arguments containing success and error function
 * @param {Function}   arg[].successCallback - Callback for successful geolocation (Optional)
 * @param {Function}   arg[].errorCB         - Callback for failed geolocation (Optional)
 */

detectCurrentLocation = function() {
  var arg, positionOptions, ref;
  arg = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  successCallback = arg[0], errorCallback = arg[1];
  if (!navigator.geolocation) {
    return typeof errorCallback === "function" ? errorCallback() : void 0;
  }
  positionOptions = ((ref = Groupon.LS.options) != null ? ref.geolocationOptions : void 0) || {};
  return checkCurrentLocation(positionOptions, success, error);
};

module.exports = {
  checkCurrentLocation: checkCurrentLocation,
  currentLocationSuccess: success,
  currentLocationError: error,
  detectCurrentLocation: detectCurrentLocation
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL2hlbHBlci9tX2RldGVjdEN1cnJlbnRMb2NhdGlvbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvc2tpbS9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9zZWFyY2gvaGVscGVyL21fZGV0ZWN0Q3VycmVudExvY2F0aW9uLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHNHQUFBO0VBQUE7O0FBQUUsWUFBYyxPQUFBLENBQVEscUJBQVI7O0FBQ2hCLGVBQUEsR0FBa0I7O0FBQ2xCLGFBQUEsR0FBa0I7OztBQUVsQjs7Ozs7Ozs7QUFPQSxPQUFBLEdBQVUsU0FBQyxRQUFEO0FBQ1IsTUFBQTtFQUFBLHlCQUFrQyxRQUFRLENBQUUsZUFBNUMsRUFBVyxVQUFWLFFBQUQsRUFBMkIsVUFBWDtFQUNoQixPQUFPLENBQUMsS0FBSyxDQUFDLFVBQWQsQ0FBeUIsNkJBQXpCLEVBQXdEO0lBQUMsS0FBQSxHQUFEO0lBQU0sS0FBQSxHQUFOO0dBQXhEO0VBQ0EsV0FBQSxDQUFZLG9CQUFaLEVBQWtDLElBQUEsR0FBTyxFQUFQLEdBQVksQ0FBOUM7RUFDQSxTQUFTLENBQUMsR0FBVixDQUFjLFFBQWQ7aURBQ0EsZ0JBQWlCO0lBQUMsS0FBQSxHQUFEO0lBQU0sS0FBQSxHQUFOO0lBQVcsT0FBQSxFQUFTLElBQXBCOztBQUxUOzs7QUFPVjs7Ozs7Ozs7QUFPQSxLQUFBLEdBQVEsU0FBQyxHQUFEO0VBQ04sT0FBTyxDQUFDLEtBQUssQ0FBQyxVQUFkLENBQXlCLHlCQUF6QixFQUFvRCxHQUFwRDtFQUNBLFNBQVMsQ0FBQyxNQUFWLENBQWlCLEdBQWpCOytDQUNBLGNBQWU7QUFIVDs7O0FBS1I7Ozs7Ozs7O0FBT0Esb0JBQUEsR0FBdUIsU0FBQyxlQUFELEVBQXVCLFNBQXZCLEVBQWtELE9BQWxEOztJQUFDLGtCQUFrQjs7O0lBQUksWUFBWSxTQUFTLENBQUM7OztJQUFLLFVBQVUsU0FBUyxDQUFDOztFQUMzRixJQUFHLGVBQWUsQ0FBQyxVQUFoQixJQUE4QixlQUFlLENBQUMsT0FBakQ7SUFDRSxTQUFTLENBQUMsV0FBVyxDQUFDLGtCQUF0QixDQUF5QyxTQUF6QyxFQUFvRCxPQUFwRCxFQUE2RCxlQUE3RCxFQURGO0dBQUEsTUFBQTtJQUdFLFNBQVMsQ0FBQyxXQUFXLENBQUMsa0JBQXRCLENBQXlDLFNBQXpDLEVBQW9ELE9BQXBELEVBSEY7O0FBRHFCOzs7QUFPdkI7Ozs7Ozs7O0FBT0EscUJBQUEsR0FBd0IsU0FBQTtBQUN0QixNQUFBO0VBRHVCO0VBQ3RCLHdCQUFELEVBQWtCO0VBQ2xCLElBQUEsQ0FBK0IsU0FBUyxDQUFDLFdBQXpDO0FBQUEsaURBQU8seUJBQVA7O0VBQ0EsZUFBQSw0Q0FBb0MsQ0FBRSw0QkFBcEIsSUFBMEM7U0FFNUQsb0JBQUEsQ0FBcUIsZUFBckIsRUFBc0MsT0FBdEMsRUFBK0MsS0FBL0M7QUFMc0I7O0FBUXhCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2Ysc0JBQUEsb0JBRGU7RUFFZixzQkFBQSxFQUF3QixPQUZUO0VBR2Ysb0JBQUEsRUFBc0IsS0FIUDtFQUlmLHVCQUFBLHFCQUplIn0=
